module.exports = __webpack_public_path__ + "static/teepee-favicon-icon-png-512-73fcd432bead6e1238d66309b9b35ced.png";